<template>
  <p class="ios-upgrade-hint" :class="{ compact }">{{ t('common.iosUpgradeHint') }}</p>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    compact?: boolean
  }>(),
  { compact: false },
)

const { t } = useI18n()
</script>

<style scoped lang="scss">
.ios-upgrade-hint {
  margin: 0;
  padding: 24px 16px 32px;
  text-align: center;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.65);

  &.compact {
    padding: 16px 12px;
    font-size: 13px;
  }
}
</style>
